import { useCallback, useState } from "react";

type Options = {
    onCopy?: () => Promise<boolean> | void;
    onDelete?: () => void;
};

export const useNotesCopyDeleteModal = (options: Options = {}) => {
    const { onCopy, onDelete } = options;
    const [open, setOpen] = useState(false);
    const [copyLabel, setCopyLabel] = useState<"Copy" | "Copied!">("Copy");

    const openModal = useCallback(() => {
        setCopyLabel("Copy");
        setOpen(true);
    }, []);
    const closeModal = useCallback(() => setOpen(false), []);

    const handleCopy = useCallback(async () => {
        const result = await onCopy?.();
        if (result !== false) {
            setCopyLabel("Copied!");
            setTimeout(() => setOpen(false), 600);
        } else {
            setOpen(false);
        }
    }, [onCopy]);

    const handleDelete = useCallback(() => {
        onDelete?.();
        setOpen(false);
    }, [onDelete]);

    return {
        open,
        copyLabel,
        openModal,
        closeModal,
        handleCopy,
        handleDelete,
    };
};
